export default __webpack_public_path__ + "static/investment-grid-background-finished-bd5ccf3deddf0c98c88eebe2fcf39582.jpg";